import { Directive } from '@angular/core';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: 'ui-kit-hint',
})
export class HintDirective {
  constructor() {}
}
